export default __webpack_public_path__ + "static/media/photo--sm--103.d851ef95.jpg";